// pages/legal/privacy-policy.page.jsx
import PageBackdrop from "../../components/ui/PageBackdrop";

const BUSINESS_NAME =
  process.env.REACT_APP_BUSINESS_NAME || "Cascade Collective LLC";
const APP_NAME = process.env.REACT_APP_NAME || "Max Stock Machine";
const CONTACT_EMAIL =
  process.env.REACT_APP_CONTACT_EMAIL || "mrzimmer77@gmail.com";
const APP_URL = process.env.REACT_APP_URL || "https://maxstockmachine.com";
const EFFECTIVE_DATE = "April 12, 2026";

export const PRIVACY_TEXT = `PRIVACY POLICY

Effective Date: ${EFFECTIVE_DATE}
Operated by: ${BUSINESS_NAME} ("Company", "we", "us", "our")

This Privacy Policy describes how ${BUSINESS_NAME} collects, uses, and shares information about you when you use ${APP_NAME} ("Service").

1. INFORMATION WE COLLECT

1.1 Account Information. When you register, we collect:
- First name and last name
- Email address
- Profile image (if provided via Google or other OAuth provider)

1.2 Usage Data. We collect information about how you use the Service, including:
- Watchlist tickers you add and configure
- Alert preferences and notification settings
- Whether you have accepted our Terms of Service and Privacy Policy, and when

1.3 Payment Information. We collect payment information through Stripe, our third-party payment processor. We do not store your full credit card number, CVV, or other sensitive payment details on our servers. Stripe's privacy policy governs the handling of your payment information.

1.4 Communications. If you contact us, we may retain records of that communication.

1.5 Automatically Collected Information. We may collect standard web server logs and usage analytics to maintain and improve the Service.

2. HOW WE USE YOUR INFORMATION

We use the information we collect to:
- Create and manage your account
- Provide, maintain, and improve the Service
- Process your subscription payments
- Send you watchlist alerts and notifications you have opted into
- Send you important account and service updates
- Respond to your inquiries and support requests
- Enforce our Terms of Service
- Comply with legal obligations

3. HOW WE SHARE YOUR INFORMATION

We do not sell, rent, or trade your personal information to third parties for their marketing purposes. We may share your information with:

3.1 Service Providers. We share information with trusted third-party service providers who assist us in operating the Service, including:
- Clerk (authentication)
- Stripe (payment processing)
- Resend (email delivery)
- Railway (hosting infrastructure)

Each service provider is bound by appropriate confidentiality and data protection obligations.

3.2 Legal Requirements. We may disclose your information if required to do so by law or in response to valid requests by public authorities.

3.3 Business Transfers. If ${BUSINESS_NAME} is involved in a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction.

4. DATA RETENTION

We retain your personal information for as long as your account is active or as needed to provide the Service. If you close your account, we will delete or anonymize your personal information within a reasonable time, unless we are required to retain it for legal or business purposes.

5. SECURITY

We implement reasonable technical and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure. We cannot guarantee absolute security.

6. YOUR RIGHTS AND CHOICES

You have the right to:
- Access the personal information we hold about you
- Request correction of inaccurate information
- Request deletion of your account and associated data
- Opt out of non-essential communications

To exercise these rights, contact us at ${CONTACT_EMAIL}.

7. EMAIL NOTIFICATIONS

We will send you transactional emails related to your account and subscription. If you opt into watchlist alerts or daily pipeline notifications, we will send those emails as configured. You can manage your notification preferences in your account settings.

8. CHILDREN'S PRIVACY

The Service is not directed to individuals under the age of 18. We do not knowingly collect personal information from children. If we become aware that a child has provided us with personal information, we will take steps to delete such information.

9. CHANGES TO THIS POLICY

We may update this Privacy Policy from time to time. We will notify you of material changes by email or by posting a notice on the Service. Your continued use of the Service after such notice constitutes your acceptance of the updated policy.

10. CONTACT

For questions about this Privacy Policy, contact us at:
${BUSINESS_NAME}
Email: ${CONTACT_EMAIL}
Website: ${APP_URL}`;

const PrivacyPolicyPage = () => (
  <>
    <style>{`
      *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
      .lp-root { background: var(--bg); min-height: 100vh; font-family: var(--font-sans); color: var(--text-primary); position: relative; }
      .lp-inner { position: relative; z-index: 1; max-width: 720px; margin: 0 auto; padding: 52px 24px 80px; }
      .lp-eyebrow { font-family: var(--font-mono); font-size: 12px; color: var(--accent); letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: 12px; }
      .lp-title { font-family: var(--font-display); font-size: clamp(28px, 4vw, 40px); font-weight: 400; line-height: 1.1; letter-spacing: -0.02em; margin-bottom: 8px; }
      .lp-effective { font-family: var(--font-mono); font-size: 12px; color: var(--text-tertiary); margin-bottom: 40px; }
      .lp-body { background: var(--surface-1); border: 1px solid var(--border-subtle); border-radius: var(--radius-md); padding: 28px; }
      .lp-pre { font-family: var(--font-mono); font-size: 13px; color: var(--text-tertiary); line-height: 1.9; white-space: pre-wrap; word-break: break-word; }
      @media (max-width: 500px) { .lp-inner { padding: 32px 16px 60px; } .lp-body { padding: 18px; } }
    `}</style>
    <div className="lp-root">
      <PageBackdrop />
      <div className="lp-inner">
        <p className="lp-eyebrow">Legal</p>
        <h1 className="lp-title">Privacy Policy</h1>
        <p className="lp-effective">
          Effective {EFFECTIVE_DATE} · {BUSINESS_NAME}
        </p>
        <div className="lp-body">
          <pre className="lp-pre">{PRIVACY_TEXT}</pre>
        </div>
      </div>
    </div>
  </>
);

export default PrivacyPolicyPage;
